import { render } from "./SearchBar.vue?vue&type=template&id=b50f6f68"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/josearpaia/Documentos/etyalab/cositas-en-vue/api-banderas-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__